import {SchedulerHeader, SchedulerHeaderProps} from "@progress/kendo-react-scheduler"
import PlannerIntervalBtnGroup from "./plannerIntervalButtonGroup"

export const PlannerSchedulerCustomHeader = (props: SchedulerHeaderProps) => {
    return (
        <SchedulerHeader>
            {props.children}
            <PlannerIntervalBtnGroup />
        </SchedulerHeader>
    )
}
